<template>
    <div class="flex gap-2">
        <div v-for="(img) in pdfImage" :key="img.image_id"
             class="group relative h-20 w-20 cursor-pointer border border-grey-40 bg-white px-1 py-1.5">
            <img :src="img.fulltext_image240_url" width="120" height="120" loading="lazy" class="h-full object-contain" />
            <img :src="img.storage_path" width="120" loading="lazy" height="120"
                 class="absolute left-0 top-20 z-10 hidden h-[300px] min-w-[450px] border border-grey-40 bg-white object-contain px-[100px] py-4 group-hover:block"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import type { ISolution, ImageRecord } from './types';
import _ from 'lodash';
import { computed } from 'vue';
const MAX_IMAGE_SHOW = 4;

const props = defineProps<{
    solutionProfile: ISolution;
}>();

const pdfImage = computed(() => {
    const imageOrigin = _.cloneDeep(props.solutionProfile?.PDF_IMAGE)
    return imageOrigin?.splice(0, MAX_IMAGE_SHOW) as ImageRecord[]
})
</script>
